export default {
  component: () => import('./page.vue'),
  path: '/archive',
  name: 'archive',
  meta: {
    title: '健康档案',
    auth: true,
  },
};
